import Parse from "parse";
import { useEffect, useState } from "react";
import { Location_Type } from "../js/parsegenerated/Location_Type";

/**
 *
 * @returns All location types specified by GTFS.
 */
export function useLocationTypes() {
  const [types, setTypes] = useState<Location_Type[]>([]);
  const [reload, setReload] = useState(0);

  useEffect(() => {
    new Parse.Query(Location_Type).find().then(setTypes);
  }, [reload]);

  return [
    types,
    () => {
      setReload((x) => x + 1);
    },
  ] as [Location_Type[], () => void];
}
